<div class="container-login">
    <div class="card card-login {{getCardLogin()}}">
        <div class="card-body">
            <div class="panel panel-primary">
                <div class="panel-heading custom-panel">
                    <div class="titulo-painel-center labels-login">
                        <h2>{{getAppTitle()}} - Autenticação</h2>
                    </div>
                </div>
            </div>

            <div>
                <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                    <div class="form-group">
                        <mat-divider fxFlex="1 0" class="mat-divider-login"></mat-divider>
                    </div>

                    <div class="form-row">
                        <div class="form-group form-group-login">
                            <label for="username" class="labels-login">
                                <mat-icon style="vertical-align: bottom;">person</mat-icon> Usuário
                            </label>
                            <input type="text" class="form-control" id="username" required trim="blur" name="username"
                                formControlName="username">

                            <div *ngIf="loginForm.controls.username.invalid && (loginForm.controls.username.dirty || loginForm.controls.username.touched)"
                                class="alert alert-danger">
                                <div *ngIf="loginForm.controls.username.errors!.required">
                                    O campo Nome é obrigatório.
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group form-group-login">
                            <label for="username" class="labels-login">
                                <mat-icon style="vertical-align: bottom;">vpn_key</mat-icon>
                                Senha
                            </label>
                            <input type="password" class="form-control" id="password" required trim="blur"
                                name="password" formControlName="password">

                            <div *ngIf="loginForm.controls.password.invalid && (loginForm.controls.password.dirty || loginForm.controls.password.touched)"
                                class="alert alert-danger">
                                <div *ngIf="loginForm.controls.password.errors!.required">
                                    O campo Senha é obrigatório.
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group">
                            <button mat-raised-button color="success" type="submit" matTooltip="Login"
                                [disabled]="!loginForm.valid">

                                Login

                            </button>
                        </div>
                    </div>

                </form>
            </div>
        </div>
    </div>
</div>